import { isSoulMapLoginPage, isSoulMapAppRoute } from '@/utils/soulmap-auth';
import { isSoulMapMode } from '@/utils/app-mode';

export const SOULMAP_SESSION_KEEPALIVE_INTERVAL_MS = 10 * 60 * 1000;
export const SOULMAP_WS_RESPONSE_TIMEOUT_MS = 180_000;
export const SOULMAP_WS_INACTIVITY_TIMEOUT_MS = 3 * 60 * 60 * 1000;
export const SOULMAP_CHAT_RESPONSE_TIMEOUT_MS = 180_000;

type SoulMapSessionRefreshFn = () => Promise<boolean>;

let sessionRefreshFn: SoulMapSessionRefreshFn | null = null;

export function registerSoulMapSessionRefresh(
  refreshFn: SoulMapSessionRefreshFn
): void {
  sessionRefreshFn = refreshFn;
}

export function unregisterSoulMapSessionRefresh(): void {
  sessionRefreshFn = null;
}

/** True only on Soul Map URLs — never on normal LiFT /login or /home routes. */
export function isSoulMapSessionRefreshEligible(pathname?: string): boolean {
  const path =
    pathname ??
    (typeof window !== 'undefined' ? window.location.pathname : '');

  if (isSoulMapMode()) {
    return true;
  }

  return isSoulMapLoginPage(path) || isSoulMapAppRoute(path);
}

export async function attemptSoulMapSessionRefresh(): Promise<boolean> {
  if (!isSoulMapSessionRefreshEligible() || !sessionRefreshFn) {
    return false;
  }

  try {
    return await sessionRefreshFn();
  } catch {
    return false;
  }
}
